<app-breadcrumbs></app-breadcrumbs>
<section class="form-wrapper">
  <div class="form-with-cover">
    <div class="form-container">
      <div class="form-title-container">
        <h1>{{ contactUsData.title }}</h1>
        <p *ngIf="!showSuccessMessage">{{ contactUsData.intro }}</p>
      </div>

      <form
        class="contact-form"
        [formGroup]="contactUsForm"
        (ngSubmit)="submit()"
        *ngIf="contactUsForm && !showSuccessMessage"
      >
        <!-- Reason field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="reason">{{ contactUsData.reason_title }}</label>
              <app-tooltip
                *ngIf="contactUsData.reason_tooltip"
                id="reason_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>
            <select
              name="reason"
              formControlName="reason"
              id="reason"
              class="bg-grey"
              [class.selected]="formControl['reason'].dirty"
              [class.placeholder]="formControl['reason'].invalid"
              [class.error]="submitted && formControl['reason'].errors"
            >
              <option disabled selected hidden value="">Please select..</option>
              <ng-container *ngFor="let reason of contactUsData.reason">
                <option [attr.value]="reason.name">
                  {{ reason.name }}
                </option>
              </ng-container>
            </select>
            <span
              class="error"
              *ngIf="submitted && formControl['reason'].errors"
            >
              {{ contactUsData.reason_validation }}
            </span>
          </div>
        </div>

        <!-- Subject Field -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="subject">{{ contactUsData.subject_title }}</label>
              <app-tooltip
                *ngIf="contactUsData.subject_tooltip"
                id="subject_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>

            <input
              formControlName="subject"
              type="text"
              name="subject"
              id="subject"
              class="bg-grey"
              [class.error]="submitted && formControl['subject'].errors"
            />

            <span
              class="error"
              *ngIf="submitted && formControl['subject'].errors"
            >
              {{ contactUsData.subject_validation }}
            </span>
          </div>
        </div>

        <!-- Message Validation -->
        <div class="form-row" *ngIf="auth.isAuthenticated()">
          <div class="form-field">
            <div class="label-container">
              <label for="message">{{ contactUsData.message_title }}</label>
              <app-tooltip
                *ngIf="contactUsData.message_tooltip"
                id="message_tooltip"
                (tooltipClicked)="openTooltip($event)"
              ></app-tooltip>
            </div>

            <textarea
              formControlName="message"
              type="text"
              name="message"
              id="message"
              class="bg-grey"
              [class.error]="submitted && formControl['message'].errors"
              maxlength="2000"
            ></textarea>

            <span
              class="error"
              *ngIf="submitted && formControl['message'].errors"
            >
              {{ contactUsData.message_validation }}
            </span>
          </div>
        </div>

        <button class="button">Submit</button>
      </form>

      <h5 *ngIf="showSuccessMessage">
        {{ contactUsData.confirmation_message }}
      </h5>
    </div>

    <div class="cover-container" *ngIf="contactUsData?.cover_image">
      <img
        [src]="contactUsData.cover_image.data.attributes.url"
        alt="Registration Cover Image"
      />
    </div>
  </div>
  <app-modal [(show)]="showTooltipModal" [showBuddy]="false">
    <app-tooltip-modal [content]="tooltipModalContent"></app-tooltip-modal>
  </app-modal>
</section>
